import React, { useEffect } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';

import useDiaryData from '../../hooks/useDiaryData';

import CalendarSection from './CalendarSection';
import ItemListSection from './ItemListSection';

const dateDisplayFormat = 'DD MMM YYYY (ddd)';

const useStyles = makeStyles(theme => ({
	calendar: {
		position: 'sticky',
		top: theme.mixins.toolbar.minHeight,
		zIndex: 1,
		backgroundColor: 'white',
	},
	date: {
		fontWeight: 600,
		marginLeft: 10,
		marginTop: 20,
		marginBottom: 10,
		fontSize: 20,
		[theme.breakpoints.up('md')]: {
			display: 'none'
		}
	},
}));

function Calendar() {
	const classes = useStyles();
	const [diary] = useDiaryData();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [diary.selectedDate]);

	return (
		<div>
			<Grid container>
				<Grid className={classes.calendar} item xs={12} md={6} lg={4}>
					<CalendarSection />
					<Typography className={classes.date}>
						{moment(diary.selectedDate).format(dateDisplayFormat)}
					</Typography>
				</Grid>

				<Grid item xs={12} md={6} lg={8}>
					<ItemListSection />
				</Grid>
			</Grid>
		</div>
	);
}

export default Calendar;
